import * as React from "react";
import type { SVGProps } from "react";
const SvgAccorCocktailGlass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M17.9666 6.06672C17.9666 4.59339 16.7666 3.38672 15.2866 3.38672C13.8066 3.38672 12.6066 4.58672 12.6066 6.06672H11.0799L10.5799 4.05339C10.5399 3.90672 10.4066 3.80005 10.2533 3.80005H7.2666V4.46672H9.99327L10.3866 6.06672H9.0266C8.83994 6.06672 8.69327 6.21339 8.69327 6.40005V20.2734C8.69327 20.4601 8.83994 20.6067 9.0266 20.6067H15.1066C15.2933 20.6067 15.4399 20.4601 15.4399 20.2734V8.72672C16.8399 8.64005 17.9533 7.48672 17.9533 6.06672H17.9666ZM14.7933 6.73339V9.44005H11.9266L11.2599 6.73339H14.7999H14.7933ZM10.5666 6.73339L11.2333 9.44005H9.37327V6.73339H10.5599H10.5666ZM15.4599 8.06005V6.40005C15.4599 6.21339 15.3133 6.06672 15.1266 6.06672H13.2799C13.2799 4.96005 14.1799 4.05339 15.2933 4.05339C16.4066 4.05339 17.3066 4.95339 17.3066 6.06672C17.3066 7.18005 16.4933 7.97339 15.4599 8.06005Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgAccorCocktailGlass;
